import { apiService } from '../utils/api';

class OAuthService {
  private static instance: OAuthService;

  private constructor() {}

  public static getInstance(): OAuthService {
    if (!OAuthService.instance) {
      OAuthService.instance = new OAuthService();
    }
    return OAuthService.instance;
  }

  public async getGoogleAuthUrl(): Promise<string> {
    try {
      const response = await apiService.getGoogleAuthUrl();
      return response.url;
    } catch (error) {
      console.error('Failed to get Google auth URL:', error);
      throw error;
    }
  }

  public async getMicrosoftAuthUrl(): Promise<string> {
    try {
      const response = await apiService.getMicrosoftAuthUrl();
      return response.url;
    } catch (error) {
      console.error('Failed to get Microsoft auth URL:', error);
      throw error;
    }
  }

  public async handleGoogleCallback(code: string): Promise<void> {
    try {
      await apiService.handleGoogleCallback(code);
    } catch (error) {
      console.error('Failed to handle Google callback:', error);
      throw error;
    }
  }

  public async handleMicrosoftCallback(code: string): Promise<void> {
    try {
      await apiService.handleMicrosoftCallback(code);
    } catch (error) {
      console.error('Failed to handle Microsoft callback:', error);
      throw error;
    }
  }

  public async getAccessToken(provider: 'google' | 'microsoft', sessionId: string): Promise<string> {
    try {
      const response = await apiService.getOAuthTokens(provider, sessionId);
      return response.access_token;
    } catch (error) {
      console.error(`Failed to get ${provider} access token:`, error);
      throw error;
    }
  }
}

export const oauthService = OAuthService.getInstance();
